module.exports = __webpack_public_path__ + "img/ag-analytics-logo.faacc2b3.png";